import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GeneralService } from '@app/core/http';
import {
  AuthService,
  DomainService,
  RouteService,
  ThemeService,
} from '@shared/services';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  domain: any;
  domainName: string;
  headerType: string;
  transactionInfo: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private generalService: GeneralService,
    public authService: AuthService,
    public routeService: RouteService,
    public domainService: DomainService,
    public themeService: ThemeService,
  ) {
    this.domain = this.domainService.get;
    this.domainName = this.domain.domain.split('.')[0];
    this.headerType = this.domain.headerType || 'v1';
    this.transactionInfo = JSON.parse(localStorage.getItem('transaction'));
  }

  ngOnInit() {
    this.generalService.transactionInfo$.subscribe((info) => {
      this.transactionInfo = info;
    });

    this.routeService.routeCheck();
    this.authService.authCheck();
    this.document.body.classList.add(this.domainName);
    this.themeService.addTag({
      rel: 'icon',
      href: '/assets/img/domain/favicon/' + this.domain.favicon,
    });

    // Super important! Theme colors should ovveride white label colors
    // 1 - Theme Colors
    // 2 - White Label Colors
    // 3 - Default Colors

    // Add specific theme classes and set CSS custom properties when theme colors are provided
    if (this.transactionInfo?.buttonColor) {
      this.document.body.classList.add('has-theme-button-color');
      this.document.documentElement.style.setProperty(
        '--theme-button-color',
        this.transactionInfo.buttonColor,
      );
    }

    if (this.transactionInfo?.headerColor) {
      this.document.body.classList.add('has-theme-header-color');
      this.document.documentElement.style.setProperty(
        '--theme-header-color',
        this.transactionInfo.headerColor,
      );
    }

    if (this.transactionInfo?.separatorColor) {
      this.document.body.classList.add('has-theme-separator-color');
      this.document.documentElement.style.setProperty(
        '--theme-separator-color',
        this.transactionInfo.separatorColor,
      );
    }
  }

  get logoUrl(): string {
    return (
      this.transactionInfo?.logoUrl ||
      `assets/img/domain/logo/${this.domain.logo}`
    );
  }
}
